import { put } from 'redux-saga/effects'
import importer from 'common/importer'

const UserActions = importer('Stores/Users/Actions')
const DonorActions = importer('Stores/Donors/Actions')

export default function * success ({ res }) {
   yield put(UserActions.sessionRefresh())
   yield put(DonorActions.getDonors(res.id))
}